import { Loader2 } from 'lucide-react';
import { AgentTab } from '../phone/tabs/AgentTab';
import { usePhoneSettingsForm } from '../phone/PhoneSettingsContext';
import { SectionFrame } from './SectionFrame';

export function AgentSection() {
  const { form, setForm, loading } = usePhoneSettingsForm();
  return (
    <SectionFrame
      title="Sprach-Agent"
      description="Vorgefertigten Agent wählen plus eigene Begrüßung, Verabschiedung und Wissensbasis."
    >
      {loading ? (
        <div className="flex h-32 items-center justify-center text-muted-foreground">
          <Loader2 className="mr-2 h-4 w-4 animate-spin" /> Lade …
        </div>
      ) : (
        <AgentTab form={form} setForm={setForm} />
      )}
    </SectionFrame>
  );
}
